(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaivik-gifting"] && !Shopify.designMode) return;
  try {
    
  function initializeGifting() {
    for (const root of document.querySelectorAll('[data-gifting]')) {
      if (root.dataset.initialized) continue;
      root.dataset.initialized = 'true';
      const cards = [...root.querySelectorAll('[data-gift-card]')];
      const count = root.querySelector('[data-gift-count]');
      for (const filter of root.querySelectorAll('[data-gift-filter]')) {
        filter.addEventListener('click', () => {
          for (const button of root.querySelectorAll('[data-gift-filter]')) button.setAttribute('aria-pressed', String(button === filter));
          let visible = 0;
          for (const card of cards) { card.hidden = filter.dataset.giftFilter !== 'all' && filter.dataset.giftFilter !== card.dataset.band; if (!card.hidden) visible++; }
          if (count) count.textContent = `${visible} ${visible === 1 ? count.dataset.singular : count.dataset.plural}`;
        });
      }
      const requestedGift = new URLSearchParams(location.search).get('gift');
      const giftChoice = root.querySelector('[data-gift-choice]');
      if (requestedGift && giftChoice) giftChoice.value = requestedGift.slice(0, 200);
      for (const link of root.querySelectorAll('[data-enquire-gift]')) link.addEventListener('click', () => { const input = root.querySelector('[data-gift-choice]'); if (input) input.value = link.dataset.enquireGift; });
    }
  }
  initializeGifting();
  document.addEventListener('shopify:section:load', initializeGifting);

  } catch(e) { console.error(e); }
})();
})();
